import * as swalConfigs from "pac/swalConfigs"
import BACKENDERROR from "app/static/frontend/imports/backenderror"
import swal from "sweetalert"
import { sendAction } from "shared/djangio/action-creators"
import { patchPacFileActionDict } from "shared/pac/types"
const { PacFile } = DjangIO.app.pac.models.pac_file

export const getSwalContent = (error) => {
    const userValidationMessage = error && error.response && error.response.data && error.response.data.message
    return {
        ...swalConfigs.ARCHIVE_PACFILE_FAILURE,
        ...(userValidationMessage && { text: userValidationMessage }),
    }
}

/**
 * This function will archive the provided PacFile.
 * The endpoint will delete FecPayrollTransactionItemizationGroup tied to the coverage period
 * and delete the coverage period if it is no longer used.
 * @param {String} id - id of the PacFile to archive
 * @returns successful swal message
 */
export const archivePacFileFromListView = (id) => async (dispatch) => {
    const isConfirm = await swal(swalConfigs.CONFIRM_ARCHIVE_PACFILE)
    if (isConfirm) {
        try {
            const response = await dispatch(
                sendAction(PacFile, patchPacFileActionDict, {
                    action: "archive_pacfile_and_coverage_period",
                    method: "patch",
                    kwargs: {
                        id,
                    },
                    payload: {},
                }),
            )
            window.dangerouslyTriggerResourceTableRefresh()
            return swal(swalConfigs.ARCHIVE_PACFILE_SUCCESS)
        } catch (error) {
            BACKENDERROR(error)
            swal(getSwalContent(error))
        }
    }
    return null
}
